import { LineClamp } from "@newsela/angelou";
import { IStandard } from "@/search/Langston/types/IStandard";
import { getGradesText } from "../../StandardsModalCheckbox/StandardsModalCheckbox.utils";
import {
  standardGradesAndYearCss,
  standardInfoCss,
  standardRegionAndTitleCss,
  standardsSetRowCss,
  standardSubjectCss,
} from "./StandardItem.styles";
import { StandardItemButtons } from "./StandardItemButtons";

interface IStandardItemProps {
  standard: IStandard;
}

export const StandardItem = ({ standard }: IStandardItemProps) => {
  const {
    description,
    grade_levels,
    adoption_year: documentAdoptYear,
    subjects: documentPrimarySubject,
    name: numberEnhanced,
  } = standard;

  return (
    <li css={standardsSetRowCss}>
      <div css={standardInfoCss}>
        <span css={standardGradesAndYearCss}>
          Grades: {getGradesText(grade_levels, true)} | {documentAdoptYear} |{" "}
          {documentPrimarySubject}
        </span>
        <span css={standardSubjectCss}>{numberEnhanced}</span>
        <LineClamp
          lines={1}
          text={`${description}`}
          innerElement="span"
          css={standardRegionAndTitleCss}
        />
      </div>
      <StandardItemButtons standard={standard} />
    </li>
  );
};
